import React from 'react';
export function Footer() {
  return <footer className="py-12 border-t border-white/5 relative z-20 bg-[#0a0a0f]" data-id="element-62">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-63">
        <div className="text-2xl font-display font-black text-white" data-id="element-64">
          פיקסל<span className="text-gradient" data-id="element-65">.</span>
        </div>

        <div className="flex items-center gap-6 text-white/50 text-sm" data-id="element-66">
          <a href="#work" className="hover:text-white transition-colors" data-id="element-67">
            עבודות
          </a>
          <a href="#services" className="hover:text-white transition-colors" data-id="element-68">
            שירותים
          </a>
          <a href="#team" className="hover:text-white transition-colors" data-id="element-69">
            צוות
          </a>
        </div>

        <div className="text-white/30 text-sm" data-id="element-70">
          © 2026 פיקסל סטודיו. כל הזכויות שמורות.
        </div>
      </div>
    </footer>;
}